var _react_refresh_temp_1;
var _react_refresh_temp_2, _react_refresh_temp_3;
_react_refresh_temp_2 = $RefreshSig$();
_react_refresh_temp_3 = $RefreshSig$();
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import i18next, {} from 'i18next';
import { useEffect, useState } from 'react';
import { initReactI18next } from 'react-i18next';
import { lucidFormattersModule } from './formatter';
export const DEFAULT_LANGUAGE = 'en';
/**
 * Initializes react-i18next service.
 */
export const initI18n = ({ 
/**
 * Fallback to the key
 */
fallbackLanguage = false, language = DEFAULT_LANGUAGE, resources, }, callback) => (_react_refresh_temp_2(), i18next
    .use(initReactI18next)
    .use(lucidFormattersModule)
    .init({
    fallbackLng: fallbackLanguage,
    interpolation: {
        // react already prevents xss
        escapeValue: false,
    },
    keySeparator: false,
    lng: language,
    nsSeparator: false,
    resources,
}, callback));
_react_refresh_temp_2(initI18n, "jXsRsKZkVelUwQyP10VEqvmyn4o=", true);
export const I18nProvider = ({ children, fallbackLanguage, language, resources, }) => {
    _react_refresh_temp_3();
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        void initI18n({
            fallbackLanguage,
            language,
            resources,
        }, (error) => {
            if (error) {
                setIsReady(false);
                throw new Error('Something went wrong with the initialization of the internationalization library.');
            }
            setIsReady(true);
        });
        return () => setIsReady(false);
    }, [fallbackLanguage, language, resources]);
    return _jsx(_Fragment, { children: isReady && children });
};
_react_refresh_temp_1 = I18nProvider;
$RefreshReg$(_react_refresh_temp_1, "I18nProvider");
_react_refresh_temp_3(I18nProvider, "5KP9N2szXKqzhBqfXaLUZqdM1dk=");
/**
 * Use the 'translate' function only inside functions and
 * never on a module level, because it depends on i18next's
 * initialization to work properly. If used on a module level
 * it will always return undefined.
 */
export const translate = i18next.t;
export { Trans, useTranslation } from 'react-i18next';
